import type { PropsWithChildren } from 'react';

import styled from 'styled-components'

import { BaseAlert, type IBaseAlertProps } from './BaseAlert'
import { IconError } from '@ui/elements/Icon/components/IconError'

export const ErrorAlert = styled(
  (props: PropsWithChildren<IBaseAlertProps>) => (
    <BaseAlert icon={<IconError block size={20} color='danger' />} {...props} />
  )
)`
  background-color: ${(props) => props.theme.colors.alert.error.background};

  border-color: ${(props) => props.theme.colors.alert.error.border};
`

ErrorAlert.displayName = 'ErrorAlert'
